export class MonthlyCostTrainPassData {
    public monthlyStatus: string
    public requestStatus: string
    public nextMonthRequestStatus: string
    public nextMonthSameLastRouteFlg: boolean
    public nextMonthSameLastMonthFlg: boolean
    public nextMonthTrainPassPurchaseFlg: boolean
    public countCostDetail: number
    public sameLastRouteFlg: boolean
    public sameLastMonthFlg: boolean
    public trainPassPurchaseFlg: boolean
    public lastMonthPurchaseFlg: boolean
}